import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EnquiryListLayer from "../components/EnquiryListLayer";

const Enquiry = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Enquiry" />
        <EnquiryListLayer />
      </MasterLayout>
    </>
  );
};

export default Enquiry;